import React, { useEffect, useState } from 'react';
import classes from '../../../../../css/layout.module.css';
import FilterSection from '../../../../../components/filter/searchFilter/SearchFilter';
import Select from '../../../../../components/filter/Select';
import Input from '../../../../../components/filter/Input';
import {
	getClientsRequest,
	getServicesRequest,
	getSMSCustomerStatusRequest,
} from '../../../../../axios/api';

const Filter = (props) => {
	const {
		selectedClient,
		selectOnChange,
		searchOnClick,
		inputOnChange,
		inputValue,
	} = props;
	const [clientData, setClientData] = useState([]);
	const [serviceData, setServiceData] = useState([]);
	const [statusData, setStatusData] = useState([]);

	useEffect(() => {
		getClientsRequest().then((res) => {
			setClientData(res.data.content);
		});
		getSMSCustomerStatusRequest().then((res) => {
			const data = res.data.map((it) => ({ id: it, name: it }));
			setStatusData(data);
		});
	}, []);

	useEffect(() => {
		if (selectedClient) {
			getServicesRequest(selectedClient).then((res) => {
				setServiceData(res.data.content);
			});
			setServiceData([]);
		}
	}, [selectedClient]);

	const filtersRender = [
		<Select
			key='client'
			label='Client'
			name='Client'
			selectOnChange={selectOnChange}
			data={clientData}
		/>,
		selectedClient ? (
			<Select
				key='service'
				label='Service'
				name='Service'
				selectOnChange={selectOnChange}
				data={serviceData}
			/>
		) : null,
		<Select
			key='select'
			label='Status'
			name='Status'
			selectOnChange={selectOnChange}
			data={statusData}
		/>,
		<Input
			key='cli'
			value={inputValue}
			name='CLI'
			type='text'
			placeholder='Enter a CLI'
			onChange={inputOnChange}
		/>,
	];

	const rightRender = (
		<button className={classes.button} onClick={searchOnClick}>
			<span>Search</span>
		</button>
	);

	return (
		<FilterSection
			singlecolumn
			form={classes.customers_filter}
			filtersRender={filtersRender}
			rightRender={rightRender}
		/>
	);
};

export default Filter;
